<template>
  <b-container fluid>
    <b-row>
      <b-col md="5" class="mb-2">
        <tree-select
          v-if="packageStatuses"
          id="select-package-status"
          :options="packageStatuses"
          v-model="select.value"
          :multiple="true"
          placeholder="Выбрать"
        >
        </tree-select>
      </b-col>
      <b-col md="3" class="pl-0 mb-2">
        <ctk-date-time-picker
          v-model="datePickerValue"
          label="Дата модификации"
          color="#40b539"
          locale="ru"
          range
          :custom-shortcuts="customShortcuts"
          format="YYYY-MM-DDTHH:mm:ssZZ"
          formatted="ll"
        >
        </ctk-date-time-picker>
      </b-col>
      <b-col md="4" class="pl-0 mb-2">
        <div class="d-flex">
          <b-input-group>
            <b-form-input id="search-input" v-model="text" placeholder="Поиск"/>
            <div class="container_search-close" @click="clearField">
              <span class="search-close">&#215;</span>
            </div>
          </b-input-group>
          <div>
            <b-button
              id="find-packages"
              variant="success"
              @click="searchPackages"
              class="ml-3 mb-2">
              <span>Найти</span>
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-table
      hover
      show-empty
      fixed
      id="data_table"
      :fields="fields"
      :items="parsedPackages"
      :busy="isBusy"
      :no-provider-paging="true"
      :no-provider-sorting="true"
      :no-provider-filtering="true"
      :current-page="currentPage"
      :per-page="perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :tbody-tr-class="rowClass"
      @filtered="onFiltered"
      @row-hovered="rowHowered"
      @row-unhovered="rowUnhowered"
      class="mt-3 blue"
      empty-text="Нет данных в таблице"
      empty-filtered-text="Нет данных по вашему запросу">

      <div slot="table-busy" class="text-center text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загрузка...</strong>
      </div>

      // Пакет
      <template slot="HEAD_id" slot-scope="data">
        <i class="fas fa-file-download"></i>{{ data.label }}
      </template>
      <template slot="id" slot-scope="row">
        <b-badge :variant="convertStatusColor(row.item.status)" class="status-badge mb-1">{{
          convertStatus(row.item.status) }}
        </b-badge>
        <div class="data-wrapper"><i class="fas fa-hashtag"></i><span class="package-number">{{ row.value }} / {{ row.item.parent_id }}</span>
        </div>
        <div class="data-wrapper"><i class="fas fa-calendar"></i><span class="created-date">{{ convertDate(row.item.create_datetime) }}</span>
        </div>
        <div class="data-wrapper"><i class="fas fa-calendar-check"></i><span class="created-date">{{ convertDate(row.item.modify_datetime) }}</span>
        </div>
      </template>

      // Назначение
      <template slot="HEAD_to" slot-scope="data">
        <i class="fas fa-arrow-up"></i>{{ data.label }}
      </template>
      <template slot="to" slot-scope="row">
        {{ convertDestination(row.value) }}
      </template>

      // Номер накладной
      <template slot="HEAD_1" slot-scope="data">
        <i class="fas fa-file-alt"></i>{{ data.label }}
      </template>
      <template slot="1" slot-scope="row">
        <div v-if="row.value" class="invoice-wrapper mb-1">
          <i class="fas fa-file-invoice"></i>
          <span class="invoice">{{ row.value }}</span>
          <i v-if="row.item.actions.visible"
             class="fas fa-copy copy-td"
             v-b-tooltip.hover
             title="Копировать"
             :id="row.value"
             @click="copyTextToClipboard(row.value, row.value, $event)"
             @mouseleave="resetTooltip(row.value, $event)">
          </i>
        </div>
      </template>

      // Инвойс
      <template slot="HEAD_2" slot-scope="data">
        <i class="fas fa-file-invoice-dollar"></i>{{ data.label }}
      </template>
      <template slot="2" slot-scope="row">
        <div v-html="row.value"></div>
      </template>

      // Организации
      <template slot="HEAD_3" slot-scope="data">
        <i class="fas fa-university"></i>{{ data.label }}
      </template>
      <template slot="3" slot-scope="row">
        <div v-html="row.value"></div>
      </template>

      // Транспорт
      <template slot="HEAD_4" slot-scope="data">
        <i class="fas fa-truck"></i>{{ data.label }}
      </template>
      <template slot="4" slot-scope="row">
        <div v-html="row.value"></div>
      </template>

      // Действия
      <template slot="HEAD_show_details" slot-scope="data">
        <i class="fas fa-info-circle"></i>{{ data.label }}
      </template>
      <template slot="show_details" slot-scope="row">
        <piportal-action-buttons
          ref="actions"
          :visible="row.item.actions.visible"
          :target="row.item.index"
          @open_documents="openDocuments(row)"
          @show_package_history="showPackageHistory(row.item.id)"
          @show_fts_exchange_history="showFtsExchangeHistory(row.item.id)">
        </piportal-action-buttons>
      </template>

      // Файлы
      <template slot="row-details" slot-scope="row">
        <div v-if="row.item.documents && row.item.documents.length || row.item.files && row.item.files.length"
             class="attachments-wrapper">
          <!--<div v-if="document.visible"-->
          <!--v-for="document in row.item.documents"-->
          <!--@click="openDocument($event, row.item.id, document)"-->
          <!--class="attachment"-->
          <!--:key="document.id"-->
          <!--:title="(document.info && document.info.name ? document.info.name : '') + ' ' + (document.title !== null ? document.title : '')"-->
          <!--:style="{ width: attachmentWidth + 'px' }">-->
          <!--<div class="attachment-inner-container">-->
          <!--<div class="file-icon-wrapper">-->
          <!--<i :class="[{ 'fas fa-file-alt' : document.ppd && !document.view, 'fas fa-file' : document.ppd && document.view, 'file-icon': true }]"></i>-->
          <!--</div>-->
          <!--<div class="attachment-name-wrapper">-->
          <!--<div class="mb-5 mr-4">{{ createDocumentName(document) }}-->
          <!--</div>-->
          <!--<span class="badge badge-secondary file-size" v-html="calcFileSize(document.size)"></span>-->
          <!--<span v-if="document.ppd && document.view" style="position: absolute; top: 3px; right: 0px">-->
          <!--<i class="fas fa-file-pdf" style="font-size: 18px; color: #40b539"></i>-->
          <!--</span>-->
          <!--</div>-->
          <!--</div>-->
          <!--</div>-->
          <div v-for="file in row.item.files"
               @click="openFile($event, row.item.id, file)"
               class="attachment"
               :key="file.id"
               :style="{ width: attachmentWidth + 'px', position: 'relative' }">
            <div class="attachment-inner-container">
              <div class="file-icon-wrapper">
                <i :class="[{ 'fas fa-file-image': true, 'file-icon': true }]"></i>
              </div>
              <div class="attachment-name-wrapper">
                <div class="mb-5 mr-4">{{ file.name }}</div>
                <span class="badge badge-secondary file-size" v-html="calcFileSize(file.size)"></span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center text-secondary my-2">
          <b-spinner class="align-middle mr-2"></b-spinner>
          <strong>Загрузка...</strong>
        </div>
      </template>
    </b-table>

    <div class="main-footer">
      <b-form inline>
        <label class="mr-3">Показать</label>
        <b-form-select :options="pageOptions" v-model="perPage"/>
      </b-form>
      <b-pagination align="center"
                    prev-text="&lt;"
                    first-text="&lt;&lt;"
                    next-text="&gt;"
                    last-text="&gt;&gt;"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-6">
      </b-pagination>
    </div>

    <b-modal class="package-modal" size="xl" id="exchangeHistory" hide-footer @hide="updateFtsHistory(null)">
      <template slot="modal-title">
        История обмена сообщениями с ФТС по пакету №{{ openPackageId }}
      </template>
      <fts-exchange-history v-if="ftsHistory && ftsHistory.length > 0" :number="openPackageId"></fts-exchange-history>
      <div v-else-if="ftsHistory && ftsHistory.length === 0" class="text-center text-secondary my-2">Нет сообщений ФТС
      </div>
      <div v-else class="text-center text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загрузка...</strong>
      </div>
    </b-modal>

    <b-modal class="package-modal" size="xl" id="packageHistory" hide-footer>
      <template slot="modal-title">
        История пакета №{{ openPackageId }}
      </template>
      <packages-history></packages-history>
    </b-modal>

    <b-modal class="package-modal" id="openHtmlDocument" size="xl" hide-footer @hide="url=null">
      <template slot="modal-title">
        {{ xmlInfo.category }}: {{ xmlInfo.description }}
      </template>
      <div>
        <b-button v-b-toggle.addition-info variant="primary" class="mb-2 mr-3 align-left document-info"><i
          class="fas fa-info text-white mr-0"></i></b-button>
        <b-button variant="success" class="mb-2 mr-3 align-right document-print" @click="loadPdf()"><i
          class="fas fa-file-pdf text-white mr-0"></i></b-button>
        <b-button class="mb-2 align-right document-print" variant="secondary"
                  @click="sendEmail({ 'packageId': openPackageId, 'documentId': openDocumentId })"><i
          class="fas fa-envelope text-white mr-0"></i></b-button>
      </div>
      <b-collapse id="addition-info" class="mb-2">
        <b-card>
          <div :key="index" class="mb-1" v-for="(key, value, index) in xmlProperties">
            <span>{{ convertProperties(value) }}:</span>&nbsp;<span><b>{{ key }}</b></span>
          </div>
        </b-card>
      </b-collapse>
      <div class="iframe-wrapper">
        <iframe :src="url" id="iframeId"></iframe>
      </div>
    </b-modal>

    <b-modal class="package-modal" id="openPpdDocument" size="xl" hide-footer @hide="updatePPD(null)">
      <div v-if="ppdDocument && ppdDocument.length"
           style="position: relative; text-align: center; width: 210mm; height: 297mm; margin: auto; z-index: 10000; border: 1px solid black">
        <span :key="index" v-for="(key, value, index) in ppdDocument">
          <span v-if="!key.Input" :class="createClassObject(key)" :style="createStyleObject(key)">{{ key.Value }}</span>
          <input v-else :value="key.Value" :style="createStyleObject(key)"/>
        </span>
      </div>
      <div v-else class="text-center text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загрузка...</strong>
      </div>
    </b-modal>

    <b-modal class="package-modal" id="openFile" size="xl" hide-footer @hide="url=null">
      <div class="iframe-wrapper">
        <iframe :src="url" id="iframeId"></iframe>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import moment from 'moment'
import { mapActions, mapMutations, mapState } from 'vuex'
import FtsExchangeHistory from './FtsExchangeHistory'
import PackagesHistory from './PackagesHistory'
import PiportalActionButtons from './PiportalActionButtons'
import colors from './json/packageStatusColors.json'
import CtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import TreeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'PiportalApiSearch',
  components: {
    CtkDateTimePicker,
    TreeSelect,
    FtsExchangeHistory,
    PackagesHistory,
    PiportalActionButtons
  },
  data () {
    return {
      fields: [
        { key: 'id', label: 'Пакет', sortable: false },
        { key: 'to', label: 'Назначение', sortable: false },
        { key: '1', label: 'Номер накладной', sortable: false },
        { key: '2', label: 'Инвойс', sortable: false },
        { key: '3', label: 'Организации', sortable: false },
        { key: '4', label: 'Транспорт', sortable: false },
        { key: 'show_details', label: 'Действия', sortable: false, tdClass: 'align-middle' }
      ],
      datePickerValue: { start: '', end: '' },
      customShortcuts: [
        { key: 'thisWeek', label: 'Эта неделя', value: 'isoWeek' },
        { key: 'thisMonth', label: 'Этот месяц', value: 'month' },
        { key: 'thisYear', label: 'Этот год', value: 'year' }
      ],
      attachmentWidth: null,
      selected: null,
      text: null,
      filterStatus: [],
      filterData: [],
      isBusy: false,
      currentPage: 1,
      totalRows: null,
      perPage: 10,
      pageOptions: [10, 20, 50],
      sortBy: 'chain_num',
      sortDesc: true,
      sortDirection: 'desc',
      openPackageId: null,
      openDocumentId: null,
      select: {
        value: []
      },
      xmlProperties: {},
      xmlInfo: {
        category: null,
        description: null,
        name: null
      },
      url: null
    }
  },
  mounted () {
    this.attachmentWidth = Math.round((window.innerWidth - 16 * 9 - 30) / 8)
    this.attachmentWidth = this.attachmentWidth < 218 ? 218 : this.attachmentWidth
    this.toggleBusy()
    this.loadPackages().then(
      result => {
        this.$options.sockets.onmessage = (message) => {
          const data = JSON.parse(message.data)
          const packageId = data.content.package
          const parsed = this.parsedPackages.filter(pkg => pkg.id === packageId)
          if (parsed && parsed.length > 0) {
            parsed[0].status = data.content.new
            parsed[0].highlight = true
            setTimeout(() => {
              parsed[0].highlight = false
            }, 2000)
          }
        }
        this.loadOperationCodes()
        this.loadCustomsMessages()
        this.loadDocumentProperties()
        this.loadPackageProperties()
        if (this.packages && this.packages.length) {
          this.totalRows = this.packages.length
        }
        this.toggleBusy()
      },
      error => {
        console.log('Rejected: loadPackages ', error)
        this.toggleBusy()
      }
    )
  },
  methods: {
    ...mapActions('piportalApiSearch', [
      'loadPackages',
      'loadPackageHistory',
      'loadPackageDocuments',
      'loadPackageFiles',
      'loadOperationCodes',
      'loadXml',
      'loadFtsExchangeHistory',
      'loadCustomsMessages',
      'loadDocumentProperties',
      'loadPackageProperties',
      'loadHtml',
      'loadPPDForms',
      'sendEmail'
    ]),
    ...mapMutations('piportalApiSearch', [
      'changeAttachmentsVisibility',
      'changeActionsVisibility',
      'updatePPD',
      'updateFtsHistory'
    ]),
    rowClass (item, type) {
      if (!item) return
      if (item.highlight) return 'row-add-success'
    },
    toggleBusy () {
      this.isBusy = !this.isBusy
    },
    createDocumentName (document) {
      const documentName = (document.info && document.info.name ? document.info.name : '') + ' ' + (document.title !== null ? document.title : '')
      return documentName.length > 45 ? documentName.substring(0, 45) + '...' : documentName
    },
    deleteUrl () {
      this.url = null
    },
    createClassObject (prop) {
      const obj = {}
      if (prop.FontAngle === '90') {
        obj.rotateText = true
      } else if (prop.FontItalic === '1') {
        obj.italicText = true
      } else if (prop.FontUnderline === '1') {
        obj.underlineText = true
      } else if (prop.FontStrikeout === '1') {
        obj.lineThroughText = true
      }
      return obj
    },
    createStyleObject (key) {
      return {
        position: 'absolute',
        top: key.Top + 'px',
        left: key.Left + 'px',
        width: key.Width + 'px',
        height: key.Height + 'px',
        'font-size': key.FontSize + 'px',
        'font-weight': key.FontWeight,
        'z-index': '1',
        border: key.Border + 'px solid black'
      }
    },
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    convertDate (date) {
      return this.moment(date).format('DD.MM.YYYY HH:mm')
    },
    convertStatus (id) {
      return this.packageStatuses.filter(status => status.id === id)[0].name
    },
    convertProperties (id) {
      return id
      // return this.documentProperties.filter(prop => prop.id === parseInt(id))[0].description
    },
    convertStatusColor (id) {
      return colors.data.filter(prop => prop.id === id)[0].color
    },
    convertDestination (destination) {
      return this.packageDeliveryCodes.filter(prop => prop.id === destination)[0].name
    },
    convertGroupId (id) {
      return this.packageProperties.filter(prop => prop.id === parseInt(id))[0].name
    },
    isVisibleGroup (id) {
      return this.packageProperties.filter(prop => prop.id === parseInt(id))[0].visible
    },
    showPackageHistory (id) {
      this.loadPackageHistory(id).then(
        result => {
          this.openPackageId = id
          this.$root.$emit('bv::show::modal', 'packageHistory', event)
        },
        error => {
          console.log(error)
        }
      )
    },
    showFtsExchangeHistory (id) {
      this.openPackageId = id
      this.$root.$emit('bv::show::modal', 'exchangeHistory', event)
      this.loadFtsExchangeHistory(id)
    },
    searchPackages () {
      const searchParams = {
        status: this.select.value,
        datetime_start: (this.datePickerValue && this.datePickerValue.start !== '' && this.datePickerValue.start !== null) ? this.datePickerValue.start : '',
        datetime_end: (this.datePickerValue && this.datePickerValue.end !== '' && this.datePickerValue.end !== null) ? this.datePickerValue.end : '',
        query: this.text
      }
      this.toggleBusy()
      this.loadPackages(searchParams).then(
        result => {
          this.currentPage = 1
          this.toggleBusy()
        },
        error => {
          console.log(error)
          this.toggleBusy()
        }
      )
    },
    openDocuments (row) {
      row.toggleDetails()
      this.loadPackageDocuments(row.item.id).then(
        result => {
          row.item.documents = this.documents.documents
        },
        error => {
          console.log(error)
        }
      )
      this.loadPackageFiles(row.item.id).then(
        result => {
          row.item.files = this.files.files
        },
        error => {
          console.log(error)
        }
      )
    },
    openDocument (event, id, document) {
      event.stopPropagation()
      if (document.view && !document.ppd) {
        this.loadView(id, document.id, document.properties, document.info)
      } else if (document.view && document.ppd) {
        this.loadView(id, document.id, document.properties, document.info)
      } else if (!document.view && document.ppd) {
        this.loadPPD(id, document.id)
      }
    },
    loadView (id, documentId, properties, info) {
      this.url = '/api/private/v3.0/packages/' + id + '/documents/' + documentId + '/view/'
      this.xmlProperties = properties
      this.xmlInfo = info
      this.openPackageId = id
      this.openDocumentId = documentId
      this.$root.$emit('bv::show::modal', 'openHtmlDocument', event)
    },
    loadPPD (id, documentId) {
      this.$root.$emit('bv::show::modal', 'openPpdDocument', event)
      this.loadPPDForms({ pkgId: id, documentId: documentId })
    },
    loadPdf () {
      const url = '/api/private/v3.0/packages/' + this.openPackageId + '/documents/' + this.openDocumentId + '/pdf/'
      window.open(url)
    },
    loadDocument (id, documentId, properties, info) {
      this.loadXml({ pkgId: id, documentId: documentId }).then(
        result => {
          this.xmlProperties = properties
          this.xmlInfo = info
          this.$root.$emit('bv::show::modal', 'openXmlDocument', event)
        },
        error => {
          console.log(error)
        }
      )
    },
    openFile (event, id, file) {
      event.stopPropagation()
      this.url = '/api/private/v3.0/packages/' + id + '/files/' + decodeURI(file.name) + '/content/'
      this.$root.$emit('bv::show::modal', 'openFile', event)
    },
    rowHowered (item, index, event) {
      item.actions.visible = true
    },
    rowUnhowered (item, index, event) {
      item.actions.visible = false
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    clearField () {
      this.text = ''
    },
    resetTooltip (text, event) {
      this.$root.$emit('bv::hide::tooltip', text.toString())
      event.target.setAttribute('data-original-title', 'Копировать')
      event.target.setAttribute('style', 'color:#78909C')
    },
    copyTextToClipboard (id, value, event) {
      event.stopPropagation()
      const copyedText = event.target.parentNode.outerText
      const textArea = document.createElement('textarea')
      textArea.value = copyedText
      document.body.appendChild(textArea)
      textArea.select()
      try {
        const successful = document.execCommand('copy')
        const msg = successful ? 'successful' : 'unsuccessful'
        this.$root.$emit('bv::hide::tooltip', id.toString())
        event.target.setAttribute('data-original-title', 'Скопировано')
        event.target.setAttribute('style', 'color: #40b539')
        this.$root.$emit('bv::show::tooltip', id.toString())
        console.log('Fallback: Copying text command was ' + msg)
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
      }
      document.body.removeChild(textArea)
    },
    calcFileSize (FileSize) {
      const FileSizeInKb = Math.floor(FileSize / 1024)
      let FileSizeInMb = 0
      let FileSizeInGb = 0
      if (FileSizeInKb > 0) {
        FileSizeInMb = Math.floor(FileSizeInKb / 1024)
        if (FileSizeInMb > 0) {
          FileSizeInGb = Math.floor(FileSizeInMb / 1024)
          if (FileSizeInGb > 0) {
            return '<span>' + FileSizeInGb + ' Гб</span>'
          } else {
            return '<span>' + FileSizeInMb + ' Мб</span>'
          }
        } else {
          return '<span>' + FileSizeInKb + ' Кб</span>'
        }
      } else {
        return '<span>' + FileSize + ' байт</span>'
      }
    }
  },
  computed: {
    ...mapState(
      {
        packageStatuses: state => state.packageStatuses,
        packageDeliveryCodes: state => state.packageDeliveryCodes,
        packages: state => state.piportalApiSearch.packages,
        xmlDocument: state => state.piportalApiSearch.xmlDocument,
        documentProperties: state => state.piportalApiSearch.documentProperties,
        packageProperties: state => state.piportalApiSearch.packageProperties,
        ppdDocument: state => state.piportalApiSearch.ppdDocument,
        arrOfIcons: state => state.piportalApiSearch.arrOfIcons,
        selectVal: state => state.piportalApiSearch.selectVal,
        documents: state => state.piportalApiSearch.documents,
        files: state => state.piportalApiSearch.files,
        ftsHistory: state => state.piportalApiSearch.ftsHistory
      }
    ),
    parsedPackages () {
      return JSON.parse(JSON.stringify(this.packages))
    }
  },
  beforeDestroy () {

  }
}
</script>

<style lang="scss" scoped>
  i {
    width: 20px;
    height: 20px;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    margin-right: 8px;
  }

  select {
    -webkit-appearance: none;
    cursor: pointer;
  }

  .input-group {
    .form-control:not(:last-child), .custom-select:not(:last-child) {
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
      font-size: 14px;
      height: 40px;
    }
  }

  .container_search-close {
    position: absolute;
    right: 11px;
    top: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    z-index: 4;
    &:hover {
      border-radius: 50%;
      background-color: #acacac;
      span {
        color: #fff;
      }
    }
    .search-close {
      font-size: 18px;
      color: #acacac;
      cursor: pointer;
      line-height: 18px;
      width: 18px;
      text-align: center;
      margin-bottom: 2px;
    }
  }

  #find-packages {
    height: 40px;
    span {
      font-size: 14px;
      font-weight: 500;
      position: relative;
      bottom: 1px;
    }
  }

  #data_table {
    width: 100%;
    table-layout: fixed;
    .status-badge {
      height: 24px;
      line-height: 16px;
      font-size: 14px;
    }
    .data-wrapper {
      i {
        font-size: 16px;
        color: #78909C;
      }
      .package-number {
        color: #37474F;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
      }
      .created-date {
        color: #373A3C;
        font-size: 14px;
        letter-spacing: 0.25px;
        line-height: 20px;
      }
    }
    .invoice-wrapper {
      position: relative;
      i {
        color: #78909C;
        font-size: 16px;
      }
      .invoice {
        color: #37474F;
        font-size: 16px;
      }
      .copy-td {
        cursor: pointer;
      }
    }
    .attachments-wrapper {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      .attachment {
        margin-right: 16px;
        margin-bottom: 16px;
        padding: 10px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
        position: relative;
        &:hover {
          box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
          cursor: pointer;
        }
        .attachment-inner-container {
          display: flex;
          width: 100%;
          word-break: break-all;
          .file-icon-wrapper {
            margin-right: 10px;
            i {
              font-size: 32px;
              color: #78909C;
              min-height: 80px;
            }
          }
          .attachment-name-wrapper {
            font-size: 14px;
            letter-spacing: 0.25px;
            line-height: 20px;
            color: #37474F;
            .file-size {
              position: absolute;
              right: 10px;
              bottom: 10px;
            }
          }
        }
      }
    }
  }

  .main-footer {
    display: flex;
    justify-content: space-between;
  }

  .iframe-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 25px;
    height: 0;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>
